export default __webpack_public_path__ + "static/media/tips.2aac2497.png";